import { Injectable } from "@angular/core";
import { UrlTree } from "@angular/router";

import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { AccountService } from "src/app/shared/services/account/account.service";

@Injectable({
  providedIn: "root",
})
export class LoginLoadGuard {
  constructor(private accountService: AccountService) {}

  canLoad():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.accountService.checkIsLoggedIn().pipe(
      map((canLoad) =>
        canLoad ? true : this.accountService.createLoginUrlTree(),
      ),
      catchError(() => of(this.accountService.createLoginUrlTree())),
    );
  }
}
